
import React, { useState } from 'react';

type Props = {
  callbackCancel: () => void | Promise<void>;
  locked?: boolean;
  label?: string;
  confirmCancel?: boolean;
  onDone?: ()=>void;
};

const ButtonCancelForm: React.FC<Props> = ({ callbackCancel, locked=false, label='Cancelar', confirmCancel=true, onDone }) => {
  const [internalLoading, setInternalLoading] = useState(false);
  const loading = locked || internalLoading;

  const handleClick = async () => {
    if (loading) return;
    if (confirmCancel) {
      const ok = window.confirm('¿Cancelar? Los cambios se perderán.');
      if (!ok) return;
    }
    try {
      setInternalLoading(true);
      await callbackCancel();
      onDone?.();
    } catch (err) {
      console.error('cancel error', err);
    } finally {
      setInternalLoading(false);
    }
  };

  return (
    <button type="button" className="btn-cancel-form" onClick={handleClick} disabled={loading} aria-busy={loading}>
      {label}
    </button>
  );
};

export default ButtonCancelForm;
